import {PeriodKey} from '../types/client-tariffs.types';

export const PERIOD_LABELS: Record<PeriodKey, string> = {
  month: 'Месяц',
  halfYear: '6 месяцев -10%',
  year: '1 год -20%',
};
